module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/19d1199b045ef18f4ba3c4280b953655.png";